const headcount_ranges = [
  { id: 0, key: 'solo', label: 'Just Me/Co-Founders' },
  { id: 1, key: '1_5', label: '1-5 employees' },
  { id: 2, key: '5_10', label: '5-10 employees' },
  { id: 3, key: '10_50', label: '10-50 employees' },
  { id: 4, key: '50_100', label: '50-100 employees' },
  { id: 5, key: '100_250', label: '100-200 employees' },
  { id: 6, key: '250_500', label: '250-500 employees' },
  { id: 7, key: '500_more', label: 'Over 500 employees' },
  { id: 8, key: 'undisclosed', label: 'Undisclosed' },
]
export default headcount_ranges
